<div class="w-full bg-white">
    <div class="w-full block header_modal">
        <h1 class="text-center text-[color:var(--second-color)] text-2xl m-0 font-bold font__title pb-4 border-b border-b-gray-300">Invitar Usuario</h1>
    </div>
    
    <div class="block w-full p-0 m-0">
        <form *ngIf="!next" (ngSubmit)="submitForm()" class="w-full grid grid-cols-[100%] gap-4 content_modal !py-0">
            <p class="m-0 text-base text-center font-medium text-gray-500">Agregue el correo electrónico del usuario que desea invitar a la organización.</p>
            <!-- <p class="m-0 text-base text-center font-medium text-gray-500">Agregue el correo electrónico del usuario o los usuarios que desea invitar a la organización.</p> -->
            <mat-form-field class="w-full !block" appearance="fill">
                <mat-label>Usuarios <span class="text-red-400">*</span></mat-label>
                <mat-chip-list #chipList>
                    <mat-chip
                        *ngFor="let item of emails"
                        [selectable]="selectable"
                        [removable]="removable"
                        (removed)="remove(item)"
                    >
                        {{item}}
                        <button matChipRemove>
                            <mat-icon>cancel</mat-icon>
                        </button>
                    </mat-chip>
                    <input
                        placeholder="Invitar a..."
                        #emailInput
                        [formControl]="emailCtrl"
                        [matAutocomplete]="auto"
                        [matChipInputFor]="chipList"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                        [matChipInputAddOnBlur]="addOnBlur"
                        (matChipInputTokenEnd)="add($event)"
                        class="!m-0 !mt-2 !block !flex-none !w-full !box-border">
                </mat-chip-list>
                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                    <mat-option *ngFor="let email of filteredEmails | async" [value]="email">
                        {{email}}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
            <div class="w-full flex flex-wrap justify-between actions_modal">
                <div class="block"></div>
                <div class="flex flex-wrap justify-between gap-4">
                    <button cdkFocusInitial mat-button class="!hidden">Autofocus disabled</button>
                    <button mat-button type="button" (click)="onNoClick()">Cancelar</button>
                    <!-- <button mat-button [mat-dialog-close]="data.input_name">Agregar</button> -->
                    <button mat-button type="submit" [disabled]="!emails||emails.length == 0" class="bg-[color:var(--primary-color)] text-white disabled:bg-gray-300">Continuar</button>
                </div>
            </div>
        </form>

        <form *ngIf="next" (ngSubmit)="submitFormOne()" [formGroup]="dataForm" class="w-full grid grid-cols-[100%] gap-4 content_modal !py-0">
            <p class="m-0 text-base text-center font-medium text-gray-500">Llene todos los campos para finalizar el registro.</p>
            <div class="w-full !block">
                <label for="role_id" class="block w-full text-[color:var(--second-color)] text-sm font-semibold mb-2">Accesos <span class="text-red-400">*</span></label>
                <ng-select2
                    [data]="roles"
                    id="role_id"
                    name="role_id"
                    formControlName="role_id"
                    [required]="true"
                    width="100%"
                    class="select_2-des"
                >
                </ng-select2>
            </div>

            <ng-container *ngIf="openFormCreateUser">
                <div class="w-full !block">
                    <label for="user_first_name" class="block w-full text-[color:var(--second-color)] text-sm font-semibold mb-2">Nombres <span class="text-red-400">*</span></label>
                    <input type="text" formControlName="user_first_name" id="user_first_name" required class="block m-0 w-full border-solid border-[1px] border-gray-300 rounded py-2 px-4 text-base">
                </div>
                <div class="w-full !block">
                    <label for="user_last_name" class="block w-full text-[color:var(--second-color)] text-sm font-semibold mb-2">Apellidos <span class="text-red-400">*</span></label>
                    <input type="text" formControlName="user_last_name" id="user_last_name" required class="block m-0 w-full border-solid border-[1px] border-gray-300 rounded py-2 px-4 text-base">
                </div>
                <div class="w-full !block">
                    <label for="user_email" class="block w-full text-[color:var(--second-color)] text-sm font-semibold mb-2">Email <span class="text-red-400">*</span></label>
                    <input type="text" formControlName="user_email" id="user_email" required class="block m-0 w-full border-solid border-[1px] border-gray-300 rounded py-2 px-4 text-base">
                </div>
                <div class="w-full !block">
                    <label for="user_cellphone" class="block w-full text-[color:var(--second-color)] text-sm font-semibold mb-2">Celular <span class="text-red-400">*</span></label>
                    <input type="text" formControlName="user_cellphone" id="user_cellphone" required class="block m-0 w-full border-solid border-[1px] border-gray-300 rounded py-2 px-4 text-base">
                </div>
            </ng-container>
            
            <div class="w-full flex flex-wrap justify-between actions_modal">
                <div class="block"></div>
                <div class="flex flex-wrap justify-between gap-4">
                    <button cdkFocusInitial mat-button class="!hidden">Autofocus disabled</button>
                    <button mat-button type="button" (click)="onNoClick()">Cancelar</button>
                    <!-- <button mat-button [mat-dialog-close]="data.input_name">Agregar</button> -->
                    <button mat-button type="submit" [disabled]="dataForm.invalid" class="bg-[color:var(--primary-color)] text-white disabled:bg-gray-300">Crear Organización</button>
                </div>
            </div>
        </form>
    </div>
</div>